<template>
  <!-- vee 3 provider bileşeninin kullanılan alt kümesi (Aşama 2.2). Değer alt öğenin v-model'inden
       çıkarılmaz; `:value` açıkça verilir. Kök <span> aynı DOM'u korur; kullanıcı etkileşimi köke gelen native
       olaylardan anlaşılır. Dokunma olayları yakalama evresinde dinlenir (vue-select seçenekleri mousedown'u
       durdurur); düzenleme olayları kabarcıklanırken, alt öğenin v-model ataması yapıldıktan sonra. -->
  <component :is="tag"
             @focusin.capture="onInteract" @mousedown.capture="onInteract" @keydown.capture="onInteract"
             @input="onUserEdit" @change="onUserEdit" @focusout="onUserEdit"><slot :errors="errors" :valid="valid" :invalid="invalid" /></component>
</template>

<script>
  import { validate } from '../../../utils/validationRules';

  // vue-select'in arama kutusu: yazmak ya da kutudan çıkmak değeri değiştirmez. vee 3 v-select'te yalnız
  // seçim (`input` olayı) sonrası doğruluyordu; seçim değer değişikliği olarak aşağıdaki watch'a düşer.
  const isSearchBox = target => !!(target && target.classList && target.classList.contains('vs__search'));

  export default {
    name: 'ValidationField',
    emits: [],
    inject: {
      validationForm: { default: null }
    },
    props: {
      // Alt öğenin v-model'iyle aynı ifade.
      value: { required: true },
      rules: { type: [String, Object], default: '' },
      name: { type: String, default: null }, // vee 3'ten kalan alan adı; mesaj artık adı içermez
      vid: { type: String, default: '' }, // vee 3 kimliği; köke öznitelik olarak düşmesin diye tanımlı
      tag: { type: String, default: 'span' }
    },
    data() {
      return {
        errors: [],
        valid: false,
        invalid: false,
        // Hatalar bir kez gösterildi (kullanıcı düzenledi ya da validate() çağrıldı); sonraki her değişiklik görünür doğrulanır.
        validated: false,
        // Kullanıcı alana dokundu; değer değişikliği görünür doğrulanır. Yükleme sırasındaki programatik değişiklik sessizdir.
        touched: false
      };
    },
    watch: {
      // Çoklu seçimde değer dizidir; eleman ekleme/çıkarma da doğrulamayı yeniden çalıştırır (Vue 2 dizi izleme).
      value: {
        deep: true,
        handler() {
          this.run(this.validated || this.touched);
        }
      },
      rules: {
        deep: true,
        handler() {
          this.run(this.validated);
        }
      }
    },
    created() {
      this.run(false);
      if (this.validationForm) this.validationForm.register(this);
    },
    beforeUnmount() {
      if (this.validationForm) this.validationForm.unregister(this);
    },
    methods: {
      run(show) {
        const result = validate(this.value, this.rules, this.translate);
        this.valid = result.valid;
        this.invalid = !result.valid;
        if (show) {
          this.errors = result.errors;
          this.validated = true;
        }
        return result;
      },
      // clientapp gibi $t ile çevrilir (ValidationMessage.*); i18n'siz ortamda anahtarın kendisi.
      translate(key) {
        return typeof this.$t === 'function' ? this.$t(key) : key;
      },
      /* Hataları göstererek doğrular: Promise<{ valid, errors }>. */
      validate() {
        return Promise.resolve(this.run(true));
      },
      reset() {
        this.errors = [];
        this.validated = false;
        this.touched = false;
        this.run(false);
      },
      onInteract() {
        this.touched = true;
      },
      // vee 3 aggressive modu: yazma (input/change) ve odaktan çıkma (blur) anında doğrular. Alt öğenin v-model
      // ataması üst bileşenin bir sonraki render'ında :value'ya yansır; nextTick doğrulamayı ondan sonraya bırakır.
      onUserEdit(event) {
        this.touched = true;
        if (isSearchBox(event.target)) return;
        this.$nextTick(() => this.run(true));
      }
    }
  };
</script>
